module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0134.jpg?v=4bd617be";